import { FvNum, Icon } from '@fv/client-components'
import type { SelectedQuote } from '@fv/models'
import type { DTO } from '@fv/models/core'

import { ShipperTooltip } from '@/components/ShipperTooltip'

type Props = {
  quote: DTO<SelectedQuote>
}
export const AuditPriceAlert = ({ quote }: Props) => {
  if (!quote.amountAtBooking) return null
  return (
    <ShipperTooltip
      label={
        <span>
          Original quote amount:{' '}
          <FvNum currency={quote.currency} val={quote.amountAtBooking} />
        </span>
      }
    >
      <div className="border-fv-orange bg-fv-orange-25 h-6 w-6 flex justify-center items-center rounded-full border-2 -left-2 -top-2 absolute">
        <Icon
          icon="exclamation-triangle"
          transform="shrink-3"
          className="text-fv-orange cursor-help"
        />
      </div>
    </ShipperTooltip>
  )
}
